import { z } from 'zod';

export const roleNameSchema = z
  .string()
  .min(1, 'A name for the role must be provided')
  .max(50, 'Role name cannot be longer than 50 characters');
